module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_4.cab7f13a.svg";